import useSWR from "swr";
import { useCreateSpeakingClassServiceAdminAxiosInstance } from "../../Auth/useCreateSpeakingClassServiceAdminAxiosInstance.ts";
import { WithdrawalRequestDTO } from "./WithdrawalRequestDTO.ts";
import {
  toWithdrawalRequestsApiParams,
  WithdrawalRequestsListQuery,
} from "./WithdrawalRequestsListQuery.ts";

export function useAllWithdrawalRequests(query: WithdrawalRequestsListQuery) {
  const { createAxiosInstance } =
    useCreateSpeakingClassServiceAdminAxiosInstance();
  const params = toWithdrawalRequestsApiParams(query);

  const { data, error, isLoading, mutate } = useSWR(
    ["/withdrawal-requests", JSON.stringify(params)],
    async () => {
      const { data } = await createAxiosInstance().get<{
        requests: WithdrawalRequestDTO[];
        total: number;
      }>("/withdrawal-requests", { params });
      return data;
    },
    { keepPreviousData: true },
  );

  return {
    requests: data?.requests ?? [],
    total: data?.total ?? 0,
    error,
    isLoading,
    refetch: mutate,
  };
}
